import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';
import { Typography } from 'components/ui/typography';
import { PaymentDialog } from './components/PaymentDialog';
import { useAppDispatch } from 'app/store';
import { fetchUserInfo } from 'app/store/user';
import { useAuth } from 'providers/AuthProvider';
import * as Sentry from '@sentry/react';
import { BillingActivityTabContent } from './components/BillingActivityTabContent';
import { BillingInvoiceTabContent } from './components/BillingInvoiceTabContent';
import { NotificationSettingsDialog } from './components/NotificationSettingsDialog';

const Page = () => {
  const dispatch = useAppDispatch();
  const { user } = useAuth();

  const handlePaymentSubmit = () => {
    if (!user) {
      Sentry.captureException('Payment submission failed - Not Authenticated');
      return;
    }
    dispatch(fetchUserInfo(user?.uid, user));
  };

  const handleNotificationSubmit = () => {
    if (!user) {
      Sentry.captureException('Updating Billing notifications failed - Not Authenticated');
      return;
    }
    dispatch(fetchUserInfo(user?.uid, user));
  };

  return (
    <>
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div>
          <Typography variant="h2" as="h1">
            Billing
          </Typography>
          <Typography variant="small" as="p" className="mt-1">
            Track activity, download invoices, and manage your billing details.
          </Typography>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <PaymentDialog onSubmit={handlePaymentSubmit} />
          <NotificationSettingsDialog onSubmit={handleNotificationSubmit} />
        </div>
      </div>

      <Tabs defaultValue="billing-activity" className="w-full">
        <TabsList>
          <TabsTrigger value="billing-activity">Billing Activity</TabsTrigger>
          <TabsTrigger value="invoices">Invoices</TabsTrigger>
        </TabsList>
        <BillingActivityTabContent value="billing-activity" />
        <BillingInvoiceTabContent value="invoices" />
      </Tabs>
    </>
  );
};

export default Page;
